// test1953
(1953 && 0);
